import SavedWords from "./SavedWords";
import { useRouter } from "next/router";

const InitialSearchSuggestion = ({ savedSearchWords, redirectToSearch }) => {
    const { locale } = useRouter();

    return (
        <div className="flex items-center justify-center ">
            <div className="flex flex-col mx-5 max-[991px]:gap-6 w-full">
                {savedSearchWords?.length ? (
                    <SavedWords
                        applySearch={redirectToSearch}
                        savedSearchWords={savedSearchWords}
                        title={
                            locale == "en"
                                ? "Your recently searched"
                                : "آخر البحث الذي قمت به"
                        }
                    />
                ) : null}
            </div>
        </div>
    );
};

export default InitialSearchSuggestion;
